import React, { useContext, useEffect, useRef } from 'react';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Button,
  DialogActions,
  Typography,
  FormControlLabel,
  Switch,
  ButtonGroup
} from '@material-ui/core';
import moment from 'moment';
import DetailedTable from '../DetailedTable';
import EventDetailsDialog from '../../containers/ErrorDiagnosis/EventDetailsDialog';
import ErrorsFilterExpansion from '../../containers/ErrorDiagnosis/ErrorsFilterExpansion';
import AuditDetailsDialog from '../../containers/ErrorDiagnosis/AuditDetailsDialog';

interface ErrorDiagnosisProps {
  data?: any;
  columns?: any;
  tableCount?: any;
  onRowSelection?: any;
  id?: any;
  ErrorDiagnosisActions?: any;
  workflowCode?: any;
  handlePageNumber?: any;
  page?: any;
  dataType?: any;
  handleDataTypeChange?: any;
  formData?: any;
  eventDetails?: any;
  handleEventDetailsDialogClose?: any;
  handleFilterReset?: any;
  defaultFilter?: any;
  filterConfig?: any;
  errorColumns?: any;
  closeFilter?: any;
  errorCode?: any;
  isAdminLevel?: any;
  participantCode?: any;
  supportUser?: any;
  openFilter?: any;
  applyFilter?: any;
  searchFilter?: any;
  workflowList?: any;
  filterDates?: any;
  auditFormData?: any;
  auditDetails?: any;
  handleAuditDetailsDialogClose?: any;
  handleDownloadClose?: any;
  handleDownload?: (FormData: any) => void;
  downloadJSONData?: any;
  setDownloadJSONData?: (value: any) => void;
  participantType?: any;
  retryStatusData?: any;
  isParticipantLevel?: any;
}

const ErrorDiagnosis = (props: ErrorDiagnosisProps) => {
  const {
    data,
    columns,
    tableCount,
    onRowSelection,
    id,
    ErrorDiagnosisActions,
    workflowCode,
    handlePageNumber,
    dataType,
    handleFilterReset,
    filterConfig,
    errorColumns,
    closeFilter,
    errorCode,
    isAdminLevel,
    participantCode,
    supportUser,
    openFilter,
    applyFilter,
    searchFilter,
    workflowList,
    filterDates,
    auditDetails,
    auditFormData,
    handleAuditDetailsDialogClose,
    handleDownload,
    handleDownloadClose,
    setDownloadJSONData,
    downloadJSONData,
    participantType
  } = props;

  const [type, setType] = React.useState<any>('live');

  const handleDataTypeChange = (type: string) => {
    setType(type);
  };

  let filteredWorkFlowList = workflowList?.workflow?.content?.filter(
    (data: { workflowCode: string }) => data.workflowCode !== 'freightTracking'
  );
  return (
    <React.Fragment>
      {auditDetails && (
        <AuditDetailsDialog
          dialogOpen={auditDetails}
          handleDialogClose={handleAuditDetailsDialogClose}
          rowData={auditFormData}
          formData={auditFormData}
          mode={'code'}
          participantCode={participantCode}
          startDate={filterDates?.startDate}
          endDate={filterDates?.endDate}
          tableId={props.id}
        />
      )}
      {(props?.eventDetails || downloadJSONData) && (
        <EventDetailsDialog
          dialogOpen={props?.eventDetails}
          handleDialogClose={props.handleEventDetailsDialogClose}
          formData={props?.formData}
          mode={'code'}
          dataType={dataType}
          downloadJSONData={downloadJSONData}
          handleDownloadClose={handleDownloadClose}
          participantCode={participantCode}
          handleDownload={handleDownload}
          setDownloadJSONData={setDownloadJSONData}
        />
      )}
      <Grid container spacing={1} direction="row">
        <Grid item xs={openFilter ? 9 : 12} md={openFilter ? 9 : 12}>
          <DetailedTable
            key="Error Diagnosis"
            id={id || 'ErrorDiagnosis'}
            title="Error Diagnosis"
            columns={columns}
            data={data}
            count={tableCount}
            showPagination={true}
            showSelection={workflowCode === 'freightTracking' ? false : true}
            tableActions={ErrorDiagnosisActions}
            serverPagination={dataType === 'live' ? true : false}
            showSpecificPage={true}
            onSelection={onRowSelection}
            showTopPagination={true}
            actionsColumnIndex={0}
            rowsPerPage={10}
            handlePageNumber={handlePageNumber}
            page={props.page}
            isAllSelected={true}
          />
        </Grid>
        {openFilter && (
          <Grid item xs={3} md={3}>
            {
              <ErrorsFilterExpansion
                key="errors-loads-filter"
                data-id="errors-loads-filter"
                onSubmit={applyFilter}
                onReset={handleFilterReset}
                defaultFilter={searchFilter}
                filterDataConfig={filterConfig}
                errorColumns={errorColumns}
                closeFilter={closeFilter}
                errorCode={errorCode}
                isAdminLevel={props.isAdminLevel}
                workflowCode={props.workflowCode}
                participantCode={participantCode}
                supportUser={false}
                workflowList={filteredWorkFlowList || []}
                retryStatusData={props.retryStatusData}
                participantType={participantType}
                isParticipantLevel={props.isParticipantLevel}
              />
            }
          </Grid>
        )}
      </Grid>
    </React.Fragment>
  );
};

export default ErrorDiagnosis;
